import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function FieldAutoComplete({ ...props }) {
  if (props.label === "Service Level") {
    console.log(
      "value in autome",
      props.value,
      props.item,
      props.value[props.item]
    );
  }

  // useEffect(() => {
  //  {
  //   input = false,
  //   label = "",
  //   className = "",
  //   value = { Code: "STD", Description: "Standard" },
  //   error = false,
  //   errorMsg = "",
  //   onChange,
  //   options = [],
  //   item = "Description",
  // } = props;
  // }, [props]);

  return (
    <div className={`width100 ${props.className}`}>
      <Autocomplete
        id={props.id ?? ""}
        disabled={props?.disabled ?? false}
        disablePortal
        freeSolo={props.input ? true : false}
        disableClearable={false}
        value={props.value[props.item]}
        size="small"
        // defaultValue={props.value[props.item]}
        onChange={props.onChange}
        options={props.options}
        getOptionLabel={(option) => option[props.item]}
        renderInput={(params) => {
          return (
            <TextField
              className="muiTextField"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: props.input ? "search" : ""
              }}
              label={props.label}
              error={props.error}
              helperText={props.errorMsg?.msg}
            />
          );
        }}
      />
    </div>
  );
}

export default FieldAutoComplete;
